/**
 * Soft-onboard identity cached in this browser origin.
 *
 * Participant + trading key are kept across refresh so reconnecting the same
 * wallet does not force a new soft-onboard / signMessage. They must not linger
 * after an intentional Disconnect or Moonlight account switch - otherwise
 * Leaderboard "You" and Settings status leak the previous user.
 */
import { clearParticipant } from "./participant-store.js";
import { clearTradingKey } from "./trading-key-store.js";

/** Wipe participant record and trading-key cache for this origin. */
export function clearIdentitySession() {
  clearParticipant();
  clearTradingKey();
}

/**
 * Whether UI may treat a cached trading commitment as "this session's you".
 * Requires an authorized Moonlight wallet - cached key alone is not enough
 * (disconnect / shared machine must not keep showing "You").
 */
export function sessionOwnsCommitment(walletAuthorized, commitmentHex) {
  if (!walletAuthorized) return false;
  const hex = String(commitmentHex || "")
    .trim()
    .replace(/^0x/i, "")
    .toLowerCase();
  return /^[0-9a-f]{64}$/.test(hex);
}

/**
 * Commitment prefix for leaderboard matching (indexer uses 8 hex chars), or
 * "" when the session must not highlight a row as "You".
 */
export function ownCommitmentPrefix(walletAuthorized, commitmentHex) {
  if (!sessionOwnsCommitment(walletAuthorized, commitmentHex)) return "";
  return String(commitmentHex)
    .trim()
    .replace(/^0x/i, "")
    .toLowerCase()
    .slice(0, 8);
}
